export const WELLNESS_QUESTIONNAIRE = {
  pleasant: {
    question: 'How pleasant or unpleasant do you feel right now?',
    scale: '0.0 = Very Unpleasant • 0.5 = Neutral • 1.0 = Very Pleasant',
  },
  calm_excited: {
    question: 'How calm or excited do you feel right now?',
    scale: '0.0 = Very Calm • 0.5 = Neutral • 1.0 = Very Excited',
  },
  tense: {
    question: 'How tense or relaxed do you feel right now?',
    scale: '0.0 = Very Relaxed • 0.5 = Neutral • 1.0 = Very Tense',
  },
  energetic: {
    question: 'How energetic or tired do you feel right now?',
    scale: '0.0 = Very Tired • 0.5 = Neutral • 1.0 = Very Energetic',
  },
} as const;

export type WellnessMetricKey = keyof typeof WELLNESS_QUESTIONNAIRE;
